import React from 'react';
import StyledButton from 'components/Button/styles';
import { sanlamYellow, sanlamIndigo, sanlamBlue } from 'Material-UI/colors';

interface ButtonPropsType {
  children: React.ReactNode;
  fontColor?: string;
  backgroundColor?: string;
  [key: string]: any;
}

const PrimaryButton = (props: ButtonPropsType) => (
  <StyledButton backgroundColor={sanlamIndigo} {...props} />
);

const SecondaryButton = (props: ButtonPropsType) => (
  <StyledButton backgroundColor={sanlamBlue} {...props} />
);

const OrangeButton = (props: ButtonPropsType) => (
  <StyledButton
    backgroundColor={sanlamYellow}
    fontColor={sanlamIndigo}
    {...props}
  />
);

const DefaultButton = (props: ButtonPropsType) => <StyledButton {...props} />;

export { PrimaryButton, SecondaryButton, OrangeButton, DefaultButton };

export default DefaultButton;
